import '../../../app/styles/index.css'

const Preloader = () => {
  return (
    <div>
      <span className="ml-1 mt-4 flex">
        <span className="dot-animation h-1 w-1 bg-gray-400 rounded-full mx-0.5 animate-bounce" />
        <span className="dot-animation h-1 w-1 bg-gray-400 rounded-full mx-0.5 animate-bounce delay-200" />
        <span className="dot-animation h-1 w-1 bg-gray-400 rounded-full mx-0.5 animate-bounce delay-400" />
      </span>
    </div>
  )
}

export default Preloader
